<mat-card class="card-container">
    <mat-card-title>{{ product?.title }}</mat-card-title>
    <mat-card-subtitle>Source: {{ product?.source }}</mat-card-subtitle>

    <mat-card-content class="info-container">
        <c-carousel [animate]="false" transition="crossfade" class="carousel-view">
            <c-carousel-indicators></c-carousel-indicators>
            <c-carousel-inner>
                <c-carousel-item>
                    <img [src]="product?.url" alt="some image" loading="lazy" class="d-block w-100">
                </c-carousel-item>

            </c-carousel-inner>
            <!--
            <c-carousel-control caption="Previous" direction="prev"></c-carousel-control>
            <c-carousel-control caption="Next" direction="next"></c-carousel-control>
        -->
        </c-carousel>
        <h3>Summary</h3>
        <div>
            <p>Brand: {{ product?.brand }}</p>
            <p>Color: {{ product?.variation?.color }}</p>
            <p>Price: {{ product?.price | currency }}</p>
            <p>Model: {{ product?.model }}</p>
            <p>Size: {{ product?.variation?.size }}</p>

        </div>
    </mat-card-content>
    <mat-card-actions class="btn-container">
        <button mat-raised-button color="accent" [routerLink]="['/search']">Search</button>
        <button mat-raised-button color="primary" [routerLink]="['/price-history']" [queryParams]="{ upc: product?.upc }">Price history</button>
        
    </mat-card-actions>
</mat-card>